<div
  class="modal fade"
  id="uploadModalDialog"
  tabindex="-1"
  role="dialog"
  aria-labelledby="uploadModalDialogLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ header }}</h4>
        <button type="button" class="close" (click)="closeModal()">
          <img src="./assets/icons/close.svg" alt="close" />
        </button>
      </div>

      <div class="modal-body p-3">
        <alert></alert>
        <div *ngIf="!showLoader">
          <section class="content">
            <div class="row">
              <div class="col-12">
                <div
                  class="card bdr-0 bxs-1 table-card"
                  [ngClass]="showSelectFileBar == true ? 'pb-5' : 'pb-3'"
                >
                  <div class="content-style">
                    <table
                      id="dtUsers"
                      class="table table-borderless row-border w-auto mb-0"
                    >
                      <thead>
                        <tr>
                          <th
                            *ngFor="let col of columns"
                            [ngStyle]="{
                              'width.px': col.width,
                              'padding.px': 10,
                            }"
                          >
                            {{ col.label }}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngIf="data.length == 0">
                          <td colspan="5">
                            <div class="empty-message">No Document Found</div>
                          </td>
                        </tr>
                        <tr *ngFor="let content of data; let i = index">
                          <td [title]="content.fileName">
                            {{ getHalfLabel(content.fileName, 42) || "--" }}
                          </td>
                          <td [title]="content?.uploadedBy || ''">
                            {{ getHalfLabel(content.uploadedBy, 18) || "--" }}
                          </td>
                          <td>
                            {{ getFormattedDate(content.updatedAt) || "--" }}
                          </td>
                          <td class="d-flex">
                            @if (
                              showViewIcon &&
                              (!data[i].attachedFileType ||
                                [
                                  "application/pdf",
                                  "image/png",
                                  "image/jpeg",
                                ].includes(data[i].attachedFileType ?? ""))
                            ) {
                              <!-- if show ViewIcon is true then view icon will be visible , and in data if attachedFileType is coming then it will check whether it equals with above array properties, if not then no view icon, (if attachedFileType is not coming in data then no check)  -->
                              <!-- this implementation is for expene file view modal , for other view modals only viewIcon flag works -->
                              <i
                                class="fa fa-eye fa-download icon-td"
                                id=""
                                title="View Docs"
                                (click)="viewFile(content)"
                              ></i>
                            }
                            @if (showDownloadIcon) {
                              <i
                                class="fa fa-download icon-td"
                                id=""
                                title="Download Docs"
                                (click)="downloadDocs(content)"
                              ></i>
                            }
                            @if (showDeleteIcon) {
                              <img
                                src="./assets/icons/delete.svg"
                                title="Delete Docs"
                                class="mx-1 icon-td"
                                alt="Delete"
                                (click)="deleteFn(content.uniqueFileName)"
                              />
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div>
            @if (showSelectFileBar) {
              <div class="form-group w-30 mar-right text-left">
                <label for="selectFile">Select file</label>
                <input
                  id="selectFile"
                  class="upload-input"
                  type="file"
                  (change)="updateFile($event)"
                  #fileInput
                  [accept]="supportedExtensions"
                /><br />
                <div class="accepted-formats">
                  {{ acceptedFormat }}
                </div>
                @if (infoText) {
                  <div
                    class="info-text"
                    [ngClass]="infoTextStyling.infoTextWrapper?.className"
                    [ngStyle]="infoTextStyling.infoTextWrapper?.styling"
                  >
                    {{ infoText }}
                  </div>
                }
                <div *ngIf="file && isSizeError()" class="text-danger">
                  {{ sizeErrorMessage }}
                </div>
                <div
                  *ngIf="file && isFileExtensionNotSupported()"
                  class="text-danger"
                >
                  Invalid format
                </div>
              </div>
            }
            <div
              class="form-group text-right"
              [ngClass]="showSelectFileBar ? 'mt-4' : 'mt-1'"
            >
              <button
                type="button"
                class="btn btn-primary mr-3 submit-button btn-cancel"
                (click)="closeModal()"
              >
                Cancel
              </button>
              @if (showSelectFileBar) {
                <button
                  type="button"
                  class="btn btn-primary mr-3 submit-button"
                  (click)="submitData()"
                  [disabled]="
                    isFileExtensionNotSupported() ||
                    isSizeError() ||
                    isUploading ||
                    isEmployeeExited
                  "
                >
                  Upload
                </button>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body p-5" *ngIf="showLoader">
        <div class="custom-loader">
          Please wait
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </div>
  </div>
</div>

<app-view-modal></app-view-modal>

<div
  class="modal fade"
  id="confirmDltModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmDeleteModalLabel"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Delete</h4>
        <button type="button" class="close">
          <img
            src="./assets/icons/close.svg"
            (click)="fnCloseConfirmDeleteModal()"
            alt="Close"
          />
        </button>
      </div>
      <div
        class="modal-body position-relative text-center px-0"
        *ngIf="!showLoader"
      >
        <div class="content p-3 py-0">
          <div class="confirmation-message">
            <p class="text-muted f-14">
              Do you really want to delete this document? This process cannot be
              undone.
            </p>
          </div>
          <button
            type="button"
            class="btn btn-white btn-sm btn-modalDelete"
            (click)="fnCloseConfirmDeleteModal()"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm mx-2"
            (click)="fnDeleteFile()"
          >
            Confirm
          </button>
        </div>
      </div>
      <div class="modal-body p-5" *ngIf="showLoader">
        <div class="custom-loader">
          Please wait
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </div>
  </div>
</div>
